import { KeyValuePair } from "src/interfaces/bold/product/product";
import { getManufacturers } from "../../../utils/services/bold/requests"
import { useResponse } from "../useResponse";

export const useManufacturers = () => {
    return useResponse<KeyValuePair[]>(getManufacturers);
}